import { debounce } from "lodash-es";
import { QueryUserByIds, QueryUserByPinyin } from "../servers/userSelServer";
import { afterLoadUser, initSelValuesItem } from "../utils";
import GoingUtils from "@/utils/goingUtils";
import {getIdsAry} from "@/main-page/utils/UsersFactory";
import emitter from "@/events/eventBus";
import {deepClone} from "xmgoing-utils";

export function useSearchSel(
  multiple: boolean,
  defUserIds?: string,
  emit?: any,
  selMainPanel?: any,
  model?:any,
  multipleRecords=false,
  aptitudeCode?: any
) {
  let lastFetchId = 0;
  //输入名称进行查询
  const userNameKey = ref("");
  //显示搜索区域
  const showSearchDiv = ref(false);
  const systemSel = ref(false);
  //搜索出来的用户集合
  const searchUserList: any = ref([]);
  //选择的用户信息集合
  const selValues: any = ref([]);

  const selUserRecords: any = ref([]);

  const initSelValues = function (userIds) {

    selValues.value = [];
    selUserRecords.value=[];
    if(userIds==='所有人'||userIds==='allUser'){
      const itemDb= {
        "id": "allUser",
        userId:'allUser',
        "name": "所有人",
        "realName": "所有人",
      }
      selUserRecords.value=[itemDb]
      initSelValuesItem(selValues, itemDb);
      return
    }
    if(typeof(userIds)==='string'){
      userIds=getIdsAry(unref(userIds));
    }
    if (Array.isArray(userIds)) {
      userIds = userIds.join(";");
    }
    if(userIds&&userIds.length>0){
      QueryUserByIds({ ids: userIds }, (res) => {
        if (res && res.records) {
          res.records.forEach((itemDb) => {
            itemDb.check = true;
            selUserRecords.value = res.records;
            initSelValuesItem(selValues, itemDb);
          });
        }
      });
    }
  };



  const fetching=ref(false);
  const state: any = reactive({
    data: [],
    value: []
  });

  /**
   * 监听查询输入框的变化
   */
  const changeSearchVal = function () {
    if (unref(userNameKey) === "") {
      showSearchDiv.value = false;
    }
  };

  /**
   * 窗口用户查询
   */
  const winUserSearch = debounce(() => {
    if (unref(userNameKey) === "") {
      return;
    }
    showSearchDiv.value = true;
    GoingUtils.showLoading();
    unref(searchUserList).splice(0, 1000);
    state.data = [];
    //根据用户名进行查询操作
    const queryParams = {};
    if (unref(aptitudeCode) && unref(aptitudeCode) !== "") {
      queryParams["extend_aptitude"] = unref(aptitudeCode);
    }
    QueryUserByPinyin(unref(userNameKey), (res) => {
      GoingUtils.closeLoading();
      if (res && res.records) {
        const alreadySelUsers = selMainPanel.value.getSelUsers();
        afterLoadUser(res, alreadySelUsers, searchUserList);
      }
    }, true, '', queryParams);
  }, 300);

  let userListTemp:any=[];
  /**
   * 下拉框查询
   */
  const fetchUser = debounce((value) => {
    console.log("fetching user", value);
    // 单选模式或多行新增模式下，如果已有数据，则不允许再次查询
    const isSingleSelect = !unref(multiple);
    const hasData = unref(selValues) && unref(selValues).length > 0;
    if ((isSingleSelect || unref(multipleRecords)) && hasData) {
      return;
    }
    lastFetchId += 1;
    const fetchId = lastFetchId;
    state.data = [];
    fetching.value = true;
    //根据用户名进行查询操作
    const queryParams = {};
    if (unref(aptitudeCode) && unref(aptitudeCode) !== "") {
      queryParams["extend_aptitude"] = unref(aptitudeCode);
    }
    QueryUserByPinyin(
      value,
      (res) => {
        GoingUtils.closeLoading();
        if (fetchId !== lastFetchId) {
          // for fetch callback order
          return;
        }
        if(res.records&&Array.isArray(res.records)){
          userListTemp=deepClone(res.records)
          const data = res.records.map((user) => ({
            label: `${user.realName}`,
            value: user.id,
            remark: `${user.deptName}--${user.roleName}`,
          }));
          state.data = data;
        }
        fetching.value = false;
      },
      false,
      '',
      queryParams,
    );
  }, 300);

  watch(state.value, () => {
    state.data = [];
    fetching.value = false;
  });

  /**
   * select选择
   * @param itemIds
   * @param itemTexts
   */
  const _changSelect = function (itemIds, itemTexts) {
    //如果多选
    if (unref(multiple)) {
      emit("update:value", Array.isArray(itemIds)?itemIds.join(";"):(itemIds+""));
      emit("update:text", itemTexts);
    }else{
      emit("update:value", (itemIds + ""));
      emit("update:text", itemTexts);
    }
  };

  /**
   * select选择触发的事件
   */
  const changSelect = function () {
    const itemIds: Array<string> = [];
    const itemTexts: Array<string> = [];

    const currentSelValues = unref(selValues);
    // 单选或多行新增模式：只保留最后一个选择的值
    const isSingleSelect = !unref(multiple);
    const isMultipleRecords = unref(multipleRecords);

    let valuesToProcess = currentSelValues;

    if ((isSingleSelect || isMultipleRecords) && currentSelValues.length > 1) {
      // 单选或多行新增模式下，只取最后一个，清空前面的
      const lastValue = currentSelValues[currentSelValues.length - 1];
      selValues.value = [lastValue];
      valuesToProcess = [lastValue];
    }

    valuesToProcess.forEach((itemDb) => {
      itemIds.push(itemDb.value);
      itemTexts.push(itemDb.label);
    });
    _changSelect(itemIds.join(";"), itemTexts.join(";"));

    const alreadySelUsers:any=[];
    itemIds.forEach((userId)=>{
      const userDb=userListTemp.find(item => {
        return item.id === userId
      });
      if (userDb) {
        // 选择的数据在当前查询的数据中，则添加
        alreadySelUsers.push(userDb)
      } else {
        const userDb2 = valuesToProcess.find(item => {
          return item.value === userId;
        });
        if (userDb2) {
          alreadySelUsers.push({id: userDb2.value, name: userDb2.label})
        }
      }
    })

    emit("confirmOk", { alreadySelUsers });
  };


  /**
   * 单行新增
   * @param alreadySelUsers
   * @param itemIds
   * @param itemTexts
   */
  const confirmSelSingleRecords=function ({alreadySelUsers,itemIds,itemTexts,emitBack=true}:any){
    if (alreadySelUsers && alreadySelUsers.length > 0) {
      //如果多选 则把以前选择的都去掉
      if (unref(multiple)) {
        unref(selValues).splice(0, 10000);
      }
      unref(alreadySelUsers).forEach((itemDb) => {
        itemIds.push(itemDb.id);
        itemTexts.push(itemDb.realName);
        //需要判断是否为单选
        if (!unref(multiple) && unref(selValues).length >= 1) {
          unref(selValues).shift();
        }
        initSelValuesItem(selValues, itemDb);
      });
      _changSelect(itemIds.join(";"), itemTexts.join(";"));
    } else {
      unref(selValues).splice(0, 10000);
      _changSelect("", "");
    }
    if(unref(model)){
      emitter.emit('clearValidateForm',{names:[unref(model).key]});
    }
    if(emitBack!==false){
      emit('confirmOk',{alreadySelUsers: unref(alreadySelUsers), ids: unref(itemIds), texts: unref(itemTexts)});
    }
    setTimeout(() => {
      systemSel.value = false;
    }, 300);
  }


  /**
   * 多行新增
   * @param alreadySelUsers
   */
  const confirmSelMoreRecords=function ({alreadySelUsers,itemIds,itemTexts}:any){
    confirmSelSingleRecords({alreadySelUsers:[alreadySelUsers[0]],itemIds,itemTexts,emitBack:false});
    emit('confirmOk',{alreadySelUsers: unref(alreadySelUsers)});
  }

  /**
   * 选择记录 通过弹出窗口
   * @param alreadySelUsers
   */
  const selRecords = function ({ alreadySelUsers }) {
    const itemIds: Array<string> = [];
    const itemTexts: Array<string> = [];
    systemSel.value = true;
    //回写 选择都记录集合
    selUserRecords.value = alreadySelUsers;
    if(multipleRecords){
      confirmSelMoreRecords({alreadySelUsers,itemIds,itemTexts});
    }else{
      confirmSelSingleRecords({alreadySelUsers,itemIds,itemTexts});
    }
  };

  return {
    fetching,
    systemSel,
    initSelValues,
    selUserRecords,
    changSelect,
    selValues,
    selRecords,
    searchUserList,
    showSearchDiv,
    changeSearchVal,
    winUserSearch,
    userNameKey,
    state,
    fetchUser,
  };
}
